import { render, staticRenderFns } from "./ConsultNoteContainer.vue?vue&type=template&id=70e51d12&scoped=true&"
import script from "./ConsultNoteContainer.vue?vue&type=script&lang=js&"
export * from "./ConsultNoteContainer.vue?vue&type=script&lang=js&"
import style0 from "./ConsultNoteContainer.vue?vue&type=style&index=0&id=70e51d12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e51d12",
  null
  
)

export default component.exports